import { PelletsFaqItem } from "~/types/Pellets";

export const pelletsPricesFaq: PelletsFaqItem[] = [
  {
    question: "Welche Faktoren beeinflussen die Pelletspreise?",
    answer: `Die Pelletspreise werden durch mehrere Faktoren bestimmt: Bestellmenge (größere Mengen sind günstiger pro Tonne), Lieferentfernung, Lagerkapazität der Hersteller, Rohstoffverfügbarkeit und saisonale Nachfrage. Auch regionale Unterschiede spielen eine Rolle.
      `,
  },
  {
    question: "Sind in den Pelletspreisen Lieferung und MwSt. enthalten?",
    answer: `Die angezeigten Pelletspreise enthalten in der Regel die Lieferung innerhalb eines bestimmten Umkreises und die gesetzliche Mehrwertsteuer. Bei größeren Entfernungen können Aufschläge anfallen. Details zu den Lieferkonditionen finden Sie bei jedem Angebot in unserem Preisvergleich.`,
  },
  {
    question: "Wie viel kosten Pellets pro Tonne aktuell?",
    answer: `Die aktuellen Pelletspreise liegen im Durchschnitt bei etwa {{LOOSE_PRICE}} pro Tonne. Regional und je nach Anbieter können die Preise variieren. Mit unserem Preisvergleich sehen Sie die tagesaktuellen Pelletspreise für Ihre Region auf einen Blick.`,
  },
  {
    question: "Lohnt sich eine Sammelbestellung für bessere Pelletspreise?",
    answer: `Da die Pelletshändler selbständig für ihre Preise zuständig sind, lässt sich dies nicht pauschal sagen. Doch oftmals sind größere Mengen günstiger pro Tonne, besonders ab 3 oder 6 Tonnen.`,
  },
  {
    question: "Wann sind die Pelletspreise am günstigsten?",
    answer: `Pelletspreise sind traditionell in den Sommermonaten (Mai bis August) am niedrigsten, da die Nachfrage gering ist. Im Herbst und Winter steigen die Preise aufgrund der erhöhten Nachfrage in der Heizsaison.`,
  },
];
